import { ICaseDetails } from '../interfaces/cases';

export const getCaseMasterTimeline = (data?: ICaseDetails) => {
  return data?.timelines?.find((timeline) => timeline.is_master)?.id ?? null;
};

export const getCaseDedicatedTimeline = (data?: ICaseDetails) => {
  return data?.timelines?.find((timeline) => !timeline.is_master)?.id ?? null;
};
